import { useEffect, useState } from 'react'

export const useIsTwitterWebView = (): boolean => {
  const [isTwitterWebView, setIsTwitterWebView] = useState(false)

  useEffect(() => {
    const ua = navigator.userAgent
    const isTwitter = ua.includes('Twitter')

    setIsTwitterWebView(isTwitter)
  }, [])

  return isTwitterWebView
}
